import { CheckCircle } from '@sketchnote/icons';
import classNames from 'classnames';
import * as React from 'react';

export interface TileButtonProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  selected?: boolean;
  checked?: boolean;
  desc?: string;
}

export const TileButton = ({
  children,
  selected,
  className,
  desc,
  ...otherProps
}: TileButtonProps) => {
  return (
    <div
      className={classNames('flex flex-col', {
        'px-16 py-17 border rounded font-medium flex justify-between': true,
        'border-primary-500  bg-white text-primary-500': !!selected,
        'border-gray-200 bg-white text-gray-500': !selected,
        [className || '']: !!className,
      })}
      role="button"
      {...otherProps}
    >
      <span className="font-bold text-gray-999">{children}</span>
      <p className="text-sm font-regular text-gray-500">{desc}</p>

      {/* {selected ? <CheckCircle wrapperClass="ml-11 mt-3" /> : null} */}
    </div>
  );
};

export const TileButtonTwo = ({
  children,
  selected,
  className,
  checked,
  ...otherProps
}: TileButtonProps) => {
  return (
    <div
      className={classNames({
        'px-12 py-13 border rounded flex justify-between': true,
        'border-primary-500  bg-primary-100 text-primary-500': !!selected || !!checked,
        'border-gray-200 bg-gray-100': !selected,
        [className || '']: !!className,
      })}
      role="button"
      {...otherProps}
    >
      <span>{children}</span>
      {selected ? <CheckCircle wrapperClass="mr-11 mt-4" /> : null}
    </div>
  );
};
